import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  version: "1.0.0",
  alerts: [],
  categories: null,
  systemMenus: null,
  systemMenuHierarchy: [],
  productCategories: null,
  productCategoryHierarchy: null,

  merchantCategories: [],
  merchantProductCategories: null,
  merchantProductCategoryHierarchy: null,
  areas: null,
  areaHierarchy: [],
  areaMap: null,
  storeSections: [],
  sectionMap: {},
  storeBrands: [],
  brandMap: [],
  suppliers: [],
  supplierMap: {},
};

const globalDataSlice = createSlice({
  name: "globalData",
  initialState,
  reducers: {
    addAlert(state, action) {
      state.alerts.push(action.payload);
    },
    removeAlert(state, action) {
      state.alerts = state.alerts.filter((a) => a.id !== action.payload);
    },
    setStoreCategories(state, action) {
      state.categories = action.payload;
    },
    setSystemMenus(state, action) {
      state.systemMenus = action.payload.data;
      state.systemMenuHierarchy = action.payload.hierarchy;
    },
    setProductCategories(state, action) {
      state.productCategories = action.payload;
    },
    setProductCategoryHierarchy(state, action) {
      state.productCategoryHierarchy = action.payload;
    },
    setMerchantCategories(state, action) {
      state.merchantCategories = action.payload;
    },
    setMerchantProductCategories(state, action) {
      state.merchantProductCategories = action.payload;
    },
    setMerchantProductCategoryHierarchy(state, action) {
      state.merchantProductCategoryHierarchy = action.payload;
    },

    setAreas(state, action) {
      state.areas = action.payload.areas;
      state.areaHierarchy = action.payload.areaHierarchy;
      state.areaMap = action.payload.areaMap;
    },
    setStoreSections(state, action) {
      state.storeSections = action.payload;
      const map = {};
      state.storeSections.forEach((sec) => {
        map[sec.id] = sec.name;
      });
      state.sectionMap = map;
    },
    setStoreBrands(state, action) {
      state.storeBrands = action.payload;
      const map = {};
      state.storeBrands.forEach((sec) => {
        map[sec.id] = sec.name;
      });
      state.brandMap = map;
    },
    setSuppliers(state, action) {
      state.suppliers = action.payload;
      const map = {};
      state.suppliers.forEach((sec) => {
        map[sec.id] = sec.name;
      });
      state.supplierMap = map;
    },
  },
});

export const { addAlert, removeAlert, setStoreCategories, setSystemMenus, setProductCategories, setProductCategoryHierarchy, setMerchantCategories, setMerchantProductCategories, setMerchantProductCategoryHierarchy, setAreas, setStoreSections, setStoreBrands, setSuppliers } = globalDataSlice.actions;

export default globalDataSlice.reducer;
